import IndexLinks from "../IndexLinks";

const HelpTopicSecuriteIndex = () => {
  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Sécurité et accessibilité', link: '/topics/securite'},
  ]

  const links = [
    { title: 'Questions de sécurité', link: '/topics/securite/question-securite'},
    { title: 'Signaler un problème', link: '/topics/securite/signal-probleme'},
  ]

  return <IndexLinks goBackLinks={goBackLinks} links={links}/>
}

export default HelpTopicSecuriteIndex